import { USE_CASES } from "./use-cases";
import { UseCaseCard } from "./UseCaseCard";
import { UseCasesIndexHero } from "./UseCasesIndexHero";
import { MarketingPageLayout } from "../../components/MarketingPageLayout";
import { BottomCTA } from "../../sections/BottomCTA";

export function UseCasesIndexPage() {
  const sorted = [...USE_CASES].sort((a, b) => b.date.localeCompare(a.date));

  return (
    <MarketingPageLayout current="use-cases">
      <UseCasesIndexHero />
      <section className="px-[clamp(24px,5vw,80px)] pb-20">
        <div className="mx-auto max-w-[1180px]">
          <ul className="grid list-none grid-cols-1 gap-6 p-0 md:grid-cols-2 xl:grid-cols-3">
            {sorted.map((useCase) => (
              <li key={useCase.id} className="flex">
                <UseCaseCard useCase={useCase} />
              </li>
            ))}
          </ul>
        </div>
      </section>
      <BottomCTA />
    </MarketingPageLayout>
  );
}
